//This file contains api calls to survey and plan configurator:
import { GOALS_SURVEY } from '../constants/constants';
import { httpGet, httpPost } from './helper';
import { BACKOFF } from '../constants/constants';
import { waitFor } from '../utils/utils';
import { getApiOrigin } from '@hungryroot/rest';

export const getAllActiveDishtypes = () => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: '/api/get_active_dishtypes/',
      type: 'GET',
    });
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get customer favorite dishtypes. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const getDishtypes = () => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_dishtypes/`,
      type: 'GET',
    });
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get customer favorite dishtypes. Error: ${errorThrown}`
        )
      );
    });
  });
};

/** @returns {Promise<{ dishtypes: number[] }>} */
export const getCustomerDishtypes = () => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_customer_dishtypes/`,
      type: 'GET',
    });
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get customer favorite dishtypes. Error: ${errorThrown}`
        )
      );
    });
  });
};

// This is not the best way to do this - check out postConfigurator for a better way
/**
 *
 * @param {number} id
 * @param {number} rating
 * @returns
 */
export const updateCustomerDishtypes = (id, rating) => {
  return new Promise((resolve, reject) => {
    let xhr = $.post(
      `${getApiOrigin()}/api/update_customer_dishtypes/`,
      JSON.stringify({ id: id, rating: rating })
    );
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to update the customer favorite dishtypes. Error: ${errorThrown}`
        )
      );
    });
  });
};

/**
 * @param {number[]} goals
 * */
export const updateCustomerOccasionGoals = (goals) => {
  /**
   * @type {Record<string, number>} goalsObj
   * */
  let goalsObj = {};
  goals.forEach((goal) => {
    if (GOALS_SURVEY[goal] === undefined) {
      return;
    }
    goalsObj[goal] = GOALS_SURVEY[goal]['value'];
  });
  return new Promise((resolve, reject) => {
    let xhr = $.post(
      '/api/update_customer_occasion_goals/',
      JSON.stringify(goalsObj)
    );
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to update the customer occasion goals. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const getPairing = (pairing_id) => {
  // This is a function that uses the _new_ get_pairing backend API
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: `${getApiOrigin()}/api/get_pairing/`,
      contentType: 'application/json',
      dataType: 'json',
      data: { pairing_id: pairing_id, includes: 'all' },
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} When trying to fetch a pairing. Error: ${errorThrown}`
        )
      );
    });
  });
};

const getHeroPairings = (data) => {
  // This is for the featured pairing-card
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: '/api/get_hero_pairings/',
      contentType: 'application/json',
      dataType: 'json',
      data: data,
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} When trying to fetch hero pairings. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const getOrder = async (
  orderId,
  includes,
  params = {},
  recurseDepth = 0
) => {
  const apiOrigin = getApiOrigin();
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: `${apiOrigin}/api/get_order/`,
      contentType: 'application/json',
      dataType: 'json',
      data: { order_id: orderId },
    };

    // Used by feedback modal
    if (params.lastDeliveredOrder) {
      options.data.last_delivered_order = true;
    }

    if (includes) options['data']['includes'] = includes;

    let xhr = $.ajax(options);

    xhr.done((newData) => {
      if (newData.is_shuffling) {
        if (recurseDepth < BACKOFF.length - 1) {
          waitFor(BACKOFF[recurseDepth] * 1000).then(() => {
            resolve(getOrder(orderId, includes, params, recurseDepth + 1));
          });
          return;
        } else {
          reject(`Failed to getOrder, still in shuffling state ${orderId}`);
        }
      }
      resolve(newData);
    });

    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} When trying to get order. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const setPeriodicity = (id, periodicity) => {
  return new Promise((resolve, reject) => {
    let options = {
      product_id: id,
      periodicity: periodicity,
    };

    let xhr = $.post(`${getApiOrigin()}/api/set_periodicity`, options);
    xhr.done((data) => resolve(data));
    xhr.fail((jqXHR, textStatus, errorThrown) =>
      reject(
        new Error(
          `Got ${textStatus} When trying to set periodicty from a product card. Error: ${errorThrown}`
        )
      )
    );
  });
};

export const getProductCategories = () => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_product_categories/`,
      type: 'GET',
    });
    xhr.done((data) => {
      resolve(data.product_categories);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get customer favorite occasion types. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const getProductDetails = (id) => {
  return new Promise((resolve, reject) => {
    const xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_product`,
      // type: 'GET',
      data: {
        product_id: id,
        includes: 'all',
      },
    });
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get product details. Error ${errorThrown}`
        )
      );
    });
  });
};

export const getPairingDishtypes = () => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_pairing_dishtypes/`,
      type: 'GET',
    });
    xhr.done((data) => {
      resolve(data.pairing_dishtypes);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get customer favorite occasion types. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const postIssueCredit = (data) => {
  // used on /delivery-help
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/auto_issue_credit/`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `postIssueCredit: Got ${textStatus} when trying to POST on automatic issue_credit. Error: ${errorThrown}`
      );
      alert(
        'Oh no! Something has gone wrong!\nPlease contact support@hungryroot.com'
      );
    });
  });
};

/**
 *
 * @param {Array of ids} tags_ids
 * @returns Promise with { tags: [tags objects]}
 */
export const getTags = (tags_ids) => {
  return new Promise((resolve, reject) => {
    const options = {
      url: `${getApiOrigin()}/api/get_tags/`,
      type: 'GET',
    };
    if (tags_ids) {
      options['data'] = {
        tags_ids: tags_ids.join(','),
      };
    }
    let xhr = $.ajax(options);
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get tags. Error: ${errorThrown}`
        )
      );
    });
  });
};

/**
 * @params data: is the customers selected tags as a js object
 * with tag id as key and choice [0, 1, -1] as value
 */
/** @param isExplicit { boolean | null } */
export const updateCustomerTags = (preferences, isExplicit = null) => {
  return new Promise((resolve, reject) => {
    const body = {};
    body.preferences = preferences;
    if (isExplicit !== null) body.is_explicit = isExplicit;
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/update_customer_tags/`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(body),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        "Got %s when trying to update customer's tags. Error: %s",
        textStatus,
        errorThrown
      );
    });
  });
};

// can pass includes as strings
// data is an object: {preference: int, is_explicit: bool, tag_group: [tag_group_id]}
/** @returns {Promise<{ tags: import('../../../../components/quiz/quiz').CustomerTag[] }>} */
/** @param {number} data */
export const getCustomerTags = (data = {}) => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_customer_tags/`,
      type: 'GET',
      data: data,
    });
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `Got ${textStatus} when trying to get tags. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const getCyoPromos = () => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: `${getApiOrigin()}/api/get_cyo_promos/`,
      contentType: 'application/json',
      dataType: 'json',
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `CYO: Got ${textStatus} when trying to fetch cyo promos. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const getCustomerCyo = () => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: '/api/get_customer_cyo/',
      contentType: 'application/json',
      dataType: 'json',
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `CYO: Got ${textStatus} when trying to fetch customer cyo promos. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const updateCustomerCyo = (data) => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: '/api/update_customer_cyo/',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        new Error(
          `CYO: Got ${textStatus} when trying to update customer cyo promos. Error: ${errorThrown}`
        )
      );
    });
  });
};

export const skipOrder = (orderId) => {
  return httpPost('/api/skip_order/', { id: orderId });
};

export const rescheduleOrder = (orderId, date) => {
  return httpPost('/api/reschedule_order/', { id: orderId, date: date });
};

export const getTagGroup = (tag_group_id) => {
  return httpGet(
    '/api/get_tag_group/',
    tag_group_id ? { tag_group_id: tag_group_id } : null
  );
};

/**
 *
 * @param {array of tag groups} tag_group_ids
 * @returns
 */
export const getTagGroups = (tag_group_ids) => {
  return httpGet(
    '/api/get_tag_groups/',
    tag_group_ids ? { tag_groups: tag_group_ids.join(',') } : null
  );
};
